import React from 'react';
import { LogoMark } from '../brand/LogoMark';
import { linkedInIcon } from '../../data/clientLogos';
import { footer, site } from '../../data/site';
export function SiteFooter() {
  return <footer className="grain grain-dark border-t border-ridge bg-ink" data-id="element-26" data-mp="t09so711ziqf">
      <div className="mx-auto flex max-w-page flex-col gap-8 px-6 py-10 md:flex-row md:items-center md:justify-between md:px-12 xl:px-20" data-id="element-27" data-mp="sxx255h8c01r">
        <div className="flex items-center gap-5" data-id="element-28" data-mp="1lo5nf672b0kk">
          <LogoMark size={32} label={site.name} data-id="element-29" data-mp="1lmchxu86qme5" />
          <a href={site.linkedInUrl} target="_blank" rel="noopener noreferrer" aria-label={`${site.name} on LinkedIn (opens in a new tab)`} className="group inline-flex h-11 w-11 items-center justify-center focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-paper" data-id="element-30" data-mp="1qmgwvftg3929">
            <img src={linkedInIcon.src} alt="" width={22} height={22} decoding="async" loading="lazy" className="icon-on-ink h-[22px] w-[22px]" data-id="element-31" data-mp="5aoyerzg8z1u" />
          </a>
        </div>
        <div className="flex flex-col gap-1 text-[13px] leading-[1.55] text-mist md:items-end md:text-right" data-id="element-32" data-mp="1swdsuy9irqo0">
          <p data-id="element-33" data-mp="26vx1ds68t40u">{footer.builtBy}</p>
          <p data-id="element-34" data-mp="26x81ni0hbtn7">{footer.copyright}</p>
        </div>
      </div>
    </footer>;
}